// extracted by mini-css-extract-plugin
export default {"list":"list--6b9c58","list_horizontal":"list_horizontal--179a28","list_align_right":"list_align_right--5537a9","list__item":"list__item--c63418"};